/**
 * Sepet + Çekmece özelleştirmeleri (JS kısmı)
 *  - Line item property "Önizleme" satırını gizle (CSS :has desteksiz tarayıcılar için)
 *  - Çekmece açıldığında da tekrar çalışsın (dinamik render)
 */
(function(){
  'use strict';

  // Gizlenecek property isimleri (büyük/küçük harf + Türkçe/İngilizce)
  var HIDDEN_PROPS = /^(Önizleme|onizleme|Preview)\s*[:.]?$/i;

  function hidePreviewProps(root){
    root = root || document;
    // HDT + genel Shopify pattern: dt/dd çiftleri
    var dts = root.querySelectorAll('dt, .cart-item__properties > *, [class*="properties"] dt, [class*="properties"] .property-name');
    dts.forEach(function(dt){
      var txt = (dt.textContent || '').trim();
      if (!HIDDEN_PROPS.test(txt)) return;
      // dt + next dd birlikte gizlenir
      dt.setAttribute('data-prop-hidden', '1');
      var next = dt.nextElementSibling;
      if (next && /^(DD|DIV|SPAN)$/i.test(next.tagName)) next.setAttribute('data-prop-hidden', '1');
      // Eğer dt bir li/div içindeyse parent satırı gizle
      var li = dt.closest('li, p, .cart-item__property, .property-row');
      if (li) li.setAttribute('data-prop-hidden', '1');
    });
    // Bazı temalar property'yi "Önizleme: url" tek satır olarak renderlar
    var lines = root.querySelectorAll('[class*="properties"] li, [class*="properties"] p, .hdt-cart-item__property, .line-item-property');
    lines.forEach(function(line){
      var txt = (line.textContent || '').trim();
      if (/^[Öö]nizleme\s*[:.]/.test(txt)) line.setAttribute('data-prop-hidden', '1');
    });
  }

  // ═══ DISPLAY TITLE OVERRIDE ═══
  // DPO master variant tüm "Özel Ölçü" ürünlerinde aynı başlığı gösterir.
  // /cart.js'den her line'ın properties._DisplayTitle değerini okuyup
  // drawer'daki ürün başlığını gerçek ürün adıyla değiştir.
  var _titleOverrideInFlight = false;
  function overrideDisplayTitles(root){
    root = root || document;
    if (_titleOverrideInFlight) return;
    _titleOverrideInFlight = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        _titleOverrideInFlight = false;
        if (!cart || !Array.isArray(cart.items)) return;
        // Drawer item'larını bul — yaygın selector'lar
        var items = root.querySelectorAll(
          '#CartDrawer hdt-line-item, .hdt-mini-cart hdt-line-item, ' +
          '#CartDrawer .hdt-mini-cart__item, .hdt-mini-cart .hdt-mini-cart__item, ' +
          '#CartDrawer .cart-item, .cart-drawer .cart-item'
        );
        if (!items.length) return;
        // Sıra: cart.items ile DOM aynı sırada (Shopify standardı)
        for (var i = 0; i < items.length && i < cart.items.length; i++){
          var line = cart.items[i];
          var displayTitle = line && line.properties && line.properties._DisplayTitle;
          if (!displayTitle) continue;
          var itemEl = items[i];
          if (itemEl.getAttribute('data-display-title') === displayTitle) continue;
          // Başlık elementini bul: ürün linki (resim olmayan, /products/ ile başlayan ilk <a>)
          var titleEl = null;
          var anchors = itemEl.querySelectorAll('a[href*="/products/"]');
          for (var j = 0; j < anchors.length; j++){
            var a = anchors[j];
            // İçinde img yoksa ve metni varsa → başlık linki
            if (!a.querySelector('img') && a.textContent.trim().length > 0) { titleEl = a; break; }
          }
          // Fallback: yaygın class isimleri
          if (!titleEl) {
            titleEl = itemEl.querySelector(
              '.hdt-mini-cart__product-title, .hdt-mini-cart__title, ' +
              '.hdt-cart-item__name, .cart-item__name, .product-title'
            );
          }
          if (titleEl) {
            titleEl.textContent = displayTitle;
            itemEl.setAttribute('data-display-title', displayTitle);
          }
        }
      })
      .catch(function(e){ _titleOverrideInFlight = false; console.warn('[cart-cust] title override err:', e); });
  }

  function runAll(){ hidePreviewProps(); overrideDisplayTitles(); }

  // İlk çalıştırma
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', runAll);
  else runAll();

  // Sepet değiştiğinde veya drawer açıldığında tekrar çalıştır
  document.addEventListener('cart:refresh', runAll);
  document.addEventListener('cart:updated', runAll);
  document.addEventListener('cart:open', runAll);

  // Drawer DOM değiştiğinde title override'ı tekrar çalıştır
  // (ozel-olcu-plus drawer içeriğini /sections=cart-drawer ile replace ediyor)
  function watchDrawer(){
    var drawer = document.getElementById('CartDrawer') || document.querySelector('.hdt-mini-cart');
    if (!drawer) return;
    var debounceT = null;
    new MutationObserver(function(){
      clearTimeout(debounceT);
      debounceT = setTimeout(function(){ overrideDisplayTitles(drawer); hidePreviewProps(drawer); }, 120);
    }).observe(drawer, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchDrawer);
  else watchDrawer();

  // ═══ MINUS BUTTON at qty=1 → TRIGGER REMOVE ═══
  // Shopify min="1" olan qty input'unda minus devre dışı kalıyor.
  // Kullanıcı qty=1 iken minus'a tıkladığında item'ı sil.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[name="minus"]');
    if (!btn) return;
    var item = btn.closest('.hdt-cart-item, hdt-line-item, .hdt-mini-cart__item, .hdt-page-cart__item');
    if (!item) return;
    var input = item.querySelector('input[name="updates[]"], input.hdt-quantity-input');
    if (!input) return;
    var currentQty = parseInt(input.value, 10);
    if (!isFinite(currentQty) || currentQty > 1) return; // normal decrement path
    // qty === 1 → remove
    e.preventDefault();
    e.stopImmediatePropagation();
    var removeLink = item.querySelector('.hdt-mini-cart__remove, .hdt-cart-page__remove, a[href*="/cart/change"][href*="quantity=0"]');
    if (removeLink && typeof removeLink.click === 'function') {
      removeLink.click();
    } else {
      // Fallback: direct /cart/change call (no page reload expected in drawer)
      var lineAttr = input.getAttribute('data-index') || input.getAttribute('data-line');
      if (lineAttr) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: parseInt(lineAttr, 10), quantity: 0 })
        }).then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          location.reload();
        });
      }
    }
  }, true); // capture phase — önce bizim handler, sonra Shopify'ınki

  // MutationObserver — cart içeriği değişirse otomatik yakala
  if (window.MutationObserver){
    var obs = new MutationObserver(function(muts){
      var needRun = false;
      muts.forEach(function(m){
        if (m.addedNodes.length) needRun = true;
      });
      if (needRun) setTimeout(runAll, 50);
    });
    function attachObserver(){
      var targets = document.querySelectorAll('.hdt-mini-cart, .hdt-page-cart, #CartDrawer, [data-cart-drawer], main#MainContent');
      targets.forEach(function(t){ try { obs.observe(t, { childList: true, subtree: true }); } catch(e){} });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attachObserver);
    else attachObserver();
  }
})();


// ═══ CART COUNT BADGE AUTO-UPDATE ═══
// Tema'nin <hdt-cart-count> badge'i sepet eklendiginde guncellenmiyor.
// /cart/add /cart/change /cart/update /cart/clear cagrilarindan sonra
// /cart.js fetch edip badge'i guncelle.
(function(){
  'use strict';
  var CART_URLS = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i;

  function updateBadges(count) {
    var nodes = document.querySelectorAll('hdt-cart-count, .cart-count, [data-cart-count]');
    nodes.forEach(function(n){
      n.textContent = count;
      // Bos sepette badge'i gizle/goster
      if (count > 0) {
        n.removeAttribute('hidden');
        n.style.display = '';
      }
    });
  }

  function refreshCount() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(c){ updateBadges(c.item_count || 0); })
      .catch(function(){});
    // Amorf preview'lar cart re-render sonrası kayboluyor — yeniden uygula
    setTimeout(swapAmorfImages, 200);
    setTimeout(swapAmorfImages, 800);
    setTimeout(swapAmorfImages, 1600);
  }

  // ═══ AMORF SEPET GORSEL SWAP (cart sayfası — bağımsız, ozel-olcu-plus.js'e ihtiyaç yok) ═══
  // ozel-olcu-plus.js sadece ürün sayfasında yükleniyor; /cart'ta yok. Bu yüzden swap'ı
  // burada (cart-customizations.js içinde) bağımsız çalıştırıyoruz.
  function swapAmorfImages() {
    try {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(r){ return r.json(); })
        .then(function(cart){
          if (!cart || !cart.items || !cart.items.length) return;
          var imgMap = {};
          cart.items.forEach(function(item, idx){
            if (!item.properties) return;
            var pid = item.properties._previewId;
            if (pid) {
              try {
                var lsImg = localStorage.getItem('ozel_olcu_preview_' + pid);
                if (lsImg) { imgMap[idx] = lsImg; return; }
              } catch(e){}
            }
            // Fallback: line item property "Önizleme" CDN URL'i (Shopify Files'a yüklenmiş)
            if (item.properties['Önizleme']) imgMap[idx] = item.properties['Önizleme'];
            else if (item.properties._kumasImage) imgMap[idx] = item.properties._kumasImage;
          });
          if (!Object.keys(imgMap).length) return;
          // Cart page item image'larını bul (drawer ve page için)
          var imgs = document.querySelectorAll('.hdt-mini-cart__img img, .hdt-page-cart__img img, .hdt-cart-item__media img, [class*="cart-item"] img, [class*="line-item"] img');
          if (!imgs.length) return;
          // Sadece line-item içindeki img'leri filtrele (recommendations vs hariç)
          var validImgs = [];
          imgs.forEach(function(i){
            var p = i.closest('hdt-line-item, .hdt-mini-cart__item, .hdt-page-cart__item, .hdt-cart-item, [class*="line-item"]');
            if (p) validImgs.push(i);
          });
          if (!validImgs.length) validImgs = Array.from(imgs);
          Object.keys(imgMap).forEach(function(idx){
            var img = validImgs[parseInt(idx)];
            if (!img) return;
            if (img.getAttribute('data-amorf-swapped') === '1') return;
            if (img.src === imgMap[idx]) { img.setAttribute('data-amorf-swapped','1'); return; }
            img.src = imgMap[idx];
            img.removeAttribute('srcset');
            img.removeAttribute('sizes');
            img.style.objectFit = 'contain';
            img.setAttribute('data-amorf-swapped','1');
            console.log('[CartSwap] idx', idx, 'preview swapped');
          });
        })
        .catch(function(){});
    } catch(e){}
  }
  // Window'a expose — diagnostik için
  window.__swapCartImages = swapAmorfImages;
  // Sayfa açılır açılmaz bir kere çalıştır (cart sayfası ya da drawer açıkken)
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ setTimeout(swapAmorfImages, 300); });
  else setTimeout(swapAmorfImages, 300);
  // Cart event'lerinde tetikle
  ['cart:refresh','cart:updated','cart:added','cart:change','cart:open'].forEach(function(ev){
    document.addEventListener(ev, function(){ setTimeout(swapAmorfImages, 200); });
  });
  // /cart sayfasında cart container'ı için MutationObserver
  if (window.location.pathname.indexOf('/cart') === 0 && window.MutationObserver) {
    var _amorfSwapTimer = null;
    function _scheduleSwap(){ if (_amorfSwapTimer) clearTimeout(_amorfSwapTimer); _amorfSwapTimer = setTimeout(swapAmorfImages, 250); }
    var _attachAmorfObs = function(){
      var roots = document.querySelectorAll('main#MainContent, .hdt-page-cart, [class*="page-cart"], cart-items');
      if (!roots.length) { setTimeout(_attachAmorfObs, 500); return; }
      var obs = new MutationObserver(function(muts){
        for (var i=0;i<muts.length;i++){ if (muts[i].addedNodes && muts[i].addedNodes.length){ _scheduleSwap(); return; } }
      });
      roots.forEach(function(r){ try { obs.observe(r, { childList:true, subtree:true }); } catch(e){} });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', _attachAmorfObs);
    else _attachAmorfObs();
  }

  // fetch interceptor
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function(input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if (CART_URLS.test(url)) {
        p.then(function(){ setTimeout(refreshCount, 100); }).catch(function(){});
      }
      return p;
    };
  }

  // XHR interceptor (eski jQuery $.ajax kullanan kodlar icin)
  if (window.XMLHttpRequest) {
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url) {
      this.__cartUrl = url;
      return origOpen.apply(this, arguments);
    };
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function() {
      var x = this;
      x.addEventListener('load', function(){
        if (CART_URLS.test(x.__cartUrl || '')) setTimeout(refreshCount, 100);
      });
      return origSend.apply(this, arguments);
    };
  }

  // Tema event'lerini de dinle (varsa)
  ['cart:refresh','cart:updated','cart:added','cart:change'].forEach(function(ev){
    document.addEventListener(ev, refreshCount);
  });
})();

// ═══ KUPON KODU ALANI — /cart sayfası (en alta, accordion) ═══
(function () {
  'use strict';
  if (window.location.pathname.indexOf('/cart') !== 0) return;

  var BLOCK_ID = 'dv-discount-block';
  var injected = false;

  function injectDiscount() {
    if (injected || document.getElementById(BLOCK_ID)) return;

    // En alta ekle — page footer'ın SON çocuğu olarak (checkout btn + trust badge'in altı)
    var container =
      document.querySelector('.hdt-page-cart__footer-content') ||
      document.querySelector('.hdt-page-cart__footer') ||
      document.querySelector('[class*="page-cart"] [class*="footer"]');

    if (!container) return;
    injected = true;

    var block = document.createElement('div');
    block.id = BLOCK_ID;
    block.innerHTML =
      '<div class="dv-dc-outer">' +
        '<button class="dv-dc-toggle" type="button" aria-expanded="false">' +
          '<span>İndirim kodun var mı?</span>' +
          '<svg class="dv-dc-chevron" width="14" height="14" viewBox="0 0 14 14" fill="none">' +
            '<path d="M2 5l5 5 5-5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>' +
        '</button>' +
        '<div class="dv-dc-body" hidden>' +
          '<div class="dv-dc-row">' +
            '<input class="dv-dc-input" type="text" placeholder="Kupon kodunu girin"' +
              ' autocomplete="off" autocapitalize="characters" aria-label="İndirim kodu" />' +
            '<button class="dv-dc-btn" type="button">Uygula</button>' +
          '</div>' +
          '<div class="dv-dc-msg"></div>' +
        '</div>' +
      '</div>';

    // En sona ekle
    container.appendChild(block);

    var toggle  = block.querySelector('.dv-dc-toggle');
    var body    = block.querySelector('.dv-dc-body');
    var input   = block.querySelector('.dv-dc-input');
    var btn     = block.querySelector('.dv-dc-btn');
    var msg     = block.querySelector('.dv-dc-msg');

    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      body.hidden = open;
      if (!open) setTimeout(function () { input.focus(); }, 50);
    });

    function applyCode() {
      var code = (input.value || '').trim().toUpperCase();
      if (!code) { showMsg('Lütfen bir kupon kodu girin.', 'warn'); return; }
      btn.disabled = true;
      btn.textContent = '...';
      showMsg('', '');
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
    }

    btn.addEventListener('click', applyCode);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') applyCode(); });

    function showMsg(text, type) {
      msg.textContent = text;
      msg.className = 'dv-dc-msg' + (type ? ' dv-dc-msg--' + type : '');
    }
  }

  function tryInject() {
    if (!injected) injectDiscount();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tryInject);
  else tryInject();
  setTimeout(tryInject, 600);
  setTimeout(tryInject, 1500);
  ['cart:refresh', 'cart:updated'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(tryInject, 300); });
  });
})();

// ═══════════════════════════════════════════════════════════
// DVB — AR Butonu (Ürün Sayfası + Sepet)
// 1. dvbArShowForProduct(btn) → tüm ürün sayfalarında
// 2. dvbCartArClick(btn)      → sepet özel ölçü item'larında
// ═══════════════════════════════════════════════════════════
(function () {
  'use strict';

  // ── CSS ──────────────────────────────────────────────────
  var CSS = [
    // Ürün sayfası "Evinde Gör" butonu
    '.dvb-ar-product-btn{',
      'display:flex;align-items:center;justify-content:center;gap:8px;',
      'width:100%;margin-top:10px;padding:12px 16px;box-sizing:border-box;',
      'background:linear-gradient(135deg,#1a1a1f,#2a2a33);',
      'color:#fff;border:1px solid #404050;border-radius:var(--rounded-button,8px);',
      'font-size:13px;font-weight:600;letter-spacing:.3px;',
      'cursor:pointer!important;pointer-events:auto!important;',
      'font-family:inherit;transition:filter .15s;',
    '}',
    '.dvb-ar-product-btn:hover{filter:brightness(1.18);}',
    '.dvb-ar-product-btn svg{flex-shrink:0;pointer-events:none;}',
    // Sepet drawer "Halıyı Evimde Gör" butonu
    '.dvb-cart-ar-btn{',
      'display:flex;align-items:center;gap:6px;box-sizing:border-box;',
      'width:calc(100% - 3rem);margin:4px 1.5rem 10px;padding:9px 14px;',
      'background:linear-gradient(135deg,#1a1a1f,#2a2a33);',
      'color:#fff;border:1px solid #404050;border-radius:8px;',
      'font-size:12px;font-weight:600;letter-spacing:.3px;',
      'cursor:pointer!important;pointer-events:auto!important;',
      'font-family:inherit;white-space:nowrap;transition:filter .15s;',
    '}',
    '.dvb-cart-ar-btn:hover{filter:brightness(1.18);}',
    '.dvb-cart-ar-btn svg{flex-shrink:0;pointer-events:none;}',
    '@media(min-width:1150px){',
      '.dvb-cart-ar-btn{width:calc(100% - 7.2rem);margin-left:3.6rem;margin-right:3.6rem;}',
    '}'
  ].join('');

  (function injectCss() {
    if (document.getElementById('dvb-ar-css')) return;
    var s = document.createElement('style');
    s.id = 'dvb-ar-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  })();

  // ── Yardımcılar ──────────────────────────────────────────
  function parseCm(label) {
    if (!label) return 0;
    var n = parseFloat(String(label).replace(/[^0-9.,]/g, '').replace(',', '.'));
    return isNaN(n) ? 0 : n;
  }

  // "80 x 150 cm" veya "80x150" → {w:80, h:150}
  function parseDims(title) {
    if (!title) return { w: 150, h: 200 };
    var m = String(title).match(/(\d+)\s*[xX×\*]\s*(\d+)/);
    if (m) return { w: parseFloat(m[1]), h: parseFloat(m[2]) };
    return { w: 150, h: 200 };
  }

  // AR API yüklenmediyse dinamik yükle, hazır olunca callback
  function ensureAr(callback) {
    if (typeof window.dvbArShowForCartItem === 'function') { callback(); return; }
    var src = window.__dvbArScriptUrl;
    // Sayfada zaten script varsa bekle
    var maxTry = 60;
    (function poll(n) {
      if (typeof window.dvbArShowForCartItem === 'function') { callback(); return; }
      if (n <= 0) {
        // Son çare: dinamik yükle
        if (src && !window.__dvbArLoading) {
          window.__dvbArLoading = true;
          var sc = document.createElement('script');
          sc.src = src;
          sc.onload = function() {
            var t = 0;
            var iv = setInterval(function() {
              if (typeof window.dvbArShowForCartItem === 'function') { clearInterval(iv); callback(); return; }
              if (++t > 50) { clearInterval(iv); console.warn('[AR] API yüklenemedi'); }
            }, 100);
          };
          document.head.appendChild(sc);
        }
        return;
      }
      setTimeout(function() { poll(n - 1); }, 100);
    })(maxTry);
  }

  // ── 1. Ürün sayfası AR ───────────────────────────────────
  // buy-buttons.liquid: onclick="window.dvbArShowForProduct(this)"
  window.dvbArShowForProduct = function(btn) {
    var pid   = parseInt(btn.getAttribute('data-pid') || '0', 10);
    var pdata = window.__dvbProductData && window.__dvbProductData[pid];

    // Seçili variant ID'yi formdan oku
    var varInput = document.querySelector('form[action*="/cart/add"] [name="id"], [data-product-select]');
    var varId    = varInput ? parseInt(varInput.value, 10) : null;

    var imgUrl  = '';
    var vtitle  = '';

    if (pdata) {
      // Seçili varianta göre resim/boyut bul
      var vars = pdata.variants || [];
      var selVar = null;
      for (var i = 0; i < vars.length; i++) {
        if (vars[i].id === varId) { selVar = vars[i]; break; }
      }
      if (!selVar && vars.length > 0) selVar = vars[0];
      imgUrl  = (selVar && selVar.img) || pdata.featuredImg || '';
      vtitle  = (selVar && selVar.title) || '';
    }

    // Fallback: sayfadaki görünen ürün resmi
    if (!imgUrl) {
      var domImg = document.querySelector(
        '.hdt-product__media img, .product__media-item img, [data-media-type="image"] img, .hdt-gallery__slide img'
      );
      if (domImg) imgUrl = domImg.src || domImg.dataset.src || '';
    }

    if (!imgUrl) { alert('Halı görseli bulunamadı.'); return; }

    var dims = parseDims(vtitle);
    // 0 boyut koruması — bazı variantlarda sadece renk değişebilir
    var w = dims.w > 0 ? dims.w : 150;
    var h = dims.h > 0 ? dims.h : 200;

    ensureAr(function() {
      window.dvbArShowForCartItem({
        previewUrl:    imgUrl,
        widthCm:       w,
        lengthCm:      h,
        shape:         'dikdortgen',
        edgeType:      'biye',
        qualityCode:   'paradiso-plus',
        radiiJson:     '',
        productHandle: btn.getAttribute('data-handle') || ''
      });
    });
  };

  // ── 2. Sepet özel ölçü AR ────────────────────────────────
  // item-cart.liquid: onclick="window.dvbCartArClick(this)"
  window.dvbCartArClick = function(btn) {
    ensureAr(function() {
      window.dvbArShowForCartItem({
        previewUrl:    btn.getAttribute('data-preview') || '',
        widthCm:       parseCm(btn.getAttribute('data-width')),
        lengthCm:      parseCm(btn.getAttribute('data-length')),
        shape:         btn.getAttribute('data-shape') || 'dikdortgen',
        edgeType:      btn.getAttribute('data-edge')  || 'biye',
        qualityCode:   'paradiso-plus',
        radiiJson:     btn.getAttribute('data-radii') || '',
        productHandle: btn.getAttribute('data-handle') || ''
      });
    });
  };
})();
